export default function PrivacyPage() {
  return (
    <div className="min-h-screen pt-24 pb-16">
      <div className="max-w-4xl mx-auto px-6">
        <h1 className="text-4xl font-bold text-white mb-8">Privacy Policy</h1>

        <div className="prose prose-invert prose-zinc max-w-none">
          <p className="text-zinc-400 text-lg mb-8">
            Last updated: January 2026
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">1. Information We Collect</h2>
            <p className="text-zinc-400 mb-4">
              WiserWebCloud ("we", "us", or "our") collects information you provide directly to us when you:
            </p>
            <ul className="list-disc list-inside text-zinc-400 space-y-2">
              <li>Create an account or update your profile</li>
              <li>Deploy applications or use our services</li>
              <li>Contact us for support or inquiries</li>
              <li>Subscribe to our newsletters or marketing communications</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">2. How We Use Your Information</h2>
            <p className="text-zinc-400 mb-4">
              We use the information we collect to:
            </p>
            <ul className="list-disc list-inside text-zinc-400 space-y-2">
              <li>Provide, maintain, and improve our services</li>
              <li>Process transactions and send related information</li>
              <li>Send technical notices, updates, and security alerts</li>
              <li>Respond to your comments, questions, and support requests</li>
              <li>Monitor and analyze trends, usage, and activities</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">3. Data Storage and Security</h2>
            <p className="text-zinc-400 mb-4">
              We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction. Your data is stored on secure servers located in Canada and the United States.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">4. Data Sharing</h2>
            <p className="text-zinc-400 mb-4">
              We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except:
            </p>
            <ul className="list-disc list-inside text-zinc-400 space-y-2">
              <li>To service providers who assist in our operations</li>
              <li>To comply with legal obligations or protect our rights</li>
              <li>In connection with a business transfer or acquisition</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">5. Cookies and Tracking</h2>
            <p className="text-zinc-400 mb-4">
              We use cookies and similar tracking technologies to analyze trends, administer the website, and gather demographic information. You can control cookies through your browser settings.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">6. Your Rights</h2>
            <p className="text-zinc-400 mb-4">
              You have the right to:
            </p>
            <ul className="list-disc list-inside text-zinc-400 space-y-2">
              <li>Access, correct, or delete your personal data</li>
              <li>Object to or restrict processing of your data</li>
              <li>Data portability</li>
              <li>Withdraw consent at any time</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-white mb-4">7. Contact Us</h2>
            <p className="text-zinc-400">
              If you have questions about this Privacy Policy, please contact us at{' '}
              <a href="mailto:privacy@wiserwebcloud.com" className="text-orange-400 hover:text-orange-300">
                privacy@wiserwebcloud.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
